import React from 'react';
import { SbButton, BUTTON_TYPE } from 'uiCore';

/**
 * Expand/Collapse all buttons for collapsible lists
 * Used by: OrgRegistryManagement, OrgTechContextSetup
 * Accepts expandAll and collapseAll callback functions
 */
const ExpandCollapseButtons = ({ expandAll, collapseAll }) => (
  <>
    <SbButton buttonType={BUTTON_TYPE.SECONDARY} onClick={expandAll}>
      Expand All
    </SbButton>
    <SbButton buttonType={BUTTON_TYPE.SECONDARY} onClick={collapseAll}>
      Collapse All
    </SbButton>
  </>
);

export default ExpandCollapseButtons;
